import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import { get } from 'lodash'

import { api } from '@/plugins/api.service'
Vue.use(Vuex);

const vuexLocalStorage = new VuexPersistence({
  key: 'featureState',
  storage: window.localStorage
})

const setPurchasableCoupons = (coupons, setCoupons) => {
  const purchasable = coupons.filter(coupon => !!coupon.charges && coupon.manuallyControlled)

  // Pull the previously set amount of using coupons for purchase
  for (let setCoupon of setCoupons) {
    const index = purchasable.findIndex(coupon => coupon.code == setCoupon.code)

    if (index >= 0)
      purchasable[index].using = setCoupon.using
  }

  return purchasable
}

export default new Vuex.Store({
  state: {
    storeId: null,
    groupId: null,
    store: null,
    manifest: null,
    user: null,
    authToken: null,
    authorizationId: null,
    giftcardCustomization: null,
    depositCustomization: null,
    feature: null,
    posSetting: null,
    giftcardDesigns: [],

    depositDetails: {
      telephone: null,
      amount: null,
      otherAmount: null
    },

    cardDetails: {
      senderName: null,
      receiverName: null,
      receiverMobile: null,
      receiverEmail: null,
      customMessage: null,
      amount: null,
      otherAmount: null,
      designCode: null,
      bonus: null,
    },

    couponDetails: {
      telephone: null,
      cart: null
    },

    billingInfo: {
      billingEmail: null,
      billingName: null,
      billingTelephone: null,
      country: null,
      postalCode: null
    },

    currencySymbol: "$",

    purchaseInfo: {},
    
    guestTelephone: null
  },

  getters: {
    getStoreID:       (state) => state.storeId,
    getGroupID:       (state) => state.groupid,

    getStore:         (state) => state.store,
    getManifest:      (state) => state.manifest,
    
    getAuthTelephone: (state) => state.user != null ? state.user.telephone : null,
    getAuthToken:     (state) => state.user != null ? state.user.authToken : null,
    getUser:          (state) => state.user,
    getAuthId:        (state) => state.authorizationId,
    isLoggedIn:       (state) => !!state.authorizationId,
    getGuestTelephone: (state) => state.guestTelephone,
    getGiftcardCustomization: (state) => state.giftcardCustomization,
    getPosSettings: (state) => state.posSetting,
    getDepositCustomization:  (state) => state.depositCustomization,
    getBuild:         (state, getters) => {
      if (getters.getFeature) {
        if (getters.getFeature === 'GiftCard')
          return {...getters.getStore, ...getters.getGiftcardCustomization}
        if (getters.getFeature === 'Deposit')
          return {...getters.getStore, ...getters.getDepositCustomization}
      }

      return getters.getStore
    },
    getCoupons:       (state) => get(state.store, 'coupons', []),

    getFeature:       (state) => state.feature,
    getCurrenySymbol: (state) => get(state, 'build.currencySymbol', "$"),

    getDepositInfo:   (state) => state.depositDetails,
    getCardDetails:   (state) => state.cardDetails,
    getCouponDetails: (state) => state.couponDetails,
    getBillingInfo:   (state) => state.billingInfo,
    getPurchaseInfo:  (state) => state.purchaseInfo,

    getCardAmont:     (state) => +state.cardDetails.amount || +state.cardDetails.otherAmount,
    getDepositAmount: (state) => +state.depositDetails.amount || +state.depositDetails.otherAmount,
    getCouponAmount:  (state) => get(state.couponDetails, 'totalAmount', 0),
    getAmount:        (state, getters) => {
      if (getters.getFeature === 'GiftCard')
        return getters.getCardAmont
      if (getters.getFeature === 'Deposit')
        return getters.getDepositAmount
      return getters.getCouponAmount
    },

    getBonusByAmount(state) {
      const bonuses = get(state.giftcardCustomization, 'bonusesForReceiver.bonuses', []);
      const amount = +state.cardDetails.amount || +state.cardDetails.otherAmount || 0;
      const bonus = bonuses.find(bonus => bonus.amountDepositMin <= amount && (bonus.amountDepositMax >= amount || bonus.amountDepositMax === -1))
      return bonus || { bonusCash: 0 }
    },

    getDepositBonusByAmount(state) {
      const bonuses = get(state.depositCustomization, 'bonuses', []);
      const amount = +state.depositDetails.amount || +state.depositDetails.otherAmount || 0;
      const bonus = bonuses.find(bonus => bonus.amountDepositMin <= amount && (bonus.amountDepositMax >= amount || bonus.amountDepositMax === -1))
      return bonus || { bonusCash: 0 }
    },

    getDepositPointsByAmount(state) {
      const bonuses = get(state.depositCustomization, 'bonuses', []);
      const amount = +state.depositDetails.amount || +state.depositDetails.otherAmount || 0;
      const bonus = bonuses.find(bonus => bonus.amountDepositMin <= amount && (bonus.amountDepositMax >= amount || bonus.amountDepositMax === -1))
      return bonus || { bonusPoints: 0 }
    },

    isTest: () => {
      return  !!(/localhost|192.168|test.gosnappy/.test(window.location.href))
    },
    origin: (state, getters) => {
      if (getters.isTest)
        return 'https://test.gosnappy.io'
      return 'https://gosnappy.io'
    },

    OWALinkGroup: (state, getters) => {
      // Only allow going to OWA if the store supports it
      if (get(getters.getStore, 'features.orderingSupported', false)) {
        const groupId = get(getters.getStore, 'groupId', false)
        const host = window.location.origin

        if (!!groupId && !!host) {
          return `${host}/owa/snappy/detail/${groupId}`
        }
      }

      return null
    },
    OWALink: (state, getters) => {
      // Only allow going to OWA if the store supports it
      if (getters.OWALinkGroup) {
        const storeId = get(getters.getStore, 'storeId', false)
        return `${getters.OWALinkGroup}/${storeId}`
      }

      return null
    },

    getGiftcardDesigns: (state) => state.giftcardDesigns,

    getDesignUrlByCode: (state, getters) => {
      // return a function that can receive designCode parameter
      return (designCode) => {
        if (!designCode) {
          // if no parameter is passed, use the designCode in the state (for backward compatibility)
          designCode = state.cardDetails.designCode
        }
        const design = getters.getGiftcardDesigns?.find(design => design.code === designCode)
        return design ? `${getters.origin}/v1${design.designImageUrl}` : null
      }
    }
  },

  mutations: {
    setStoreID: (state, payload) => {
      state.storeId = payload
    },

    setStore: (state, payload) => {
      state.store = payload
    },
    setManifest: (state, payload) => {
      state.manifest = payload
    },

    setGiftcardCustomization: (state, payload) => {
      state.giftcardCustomization = payload
    },

    setCardDetailsDesignCode: (state, payload) => {
      state.cardDetails.designCode = payload
    },

    setGiftcardDesigns: (state, payload) => {
      state.giftcardDesigns = payload
    },
    setDepositCustomization: (state, payload) => {
      state.depositCustomization = payload
    },
    setPosSetting: (state, payload) => {
      state.posSetting = payload
    },
    setDepositDetails: (state, payload) => {
      state.depositDetails = payload
    },
    setCardDetails: (state, payload) => {
      state.cardDetails = payload
    },
    setCouponDetails: (state, payload) => {
      state.couponDetails = payload
    },
    setBillingInfo: (state, payload) => {
      state.billingInfo = payload
    },
    setPurchaseInfo: (state, payload) => {
      state.purchaseInfo = payload
    },

    setFeature: (state, payload) => {
      state.feature = payload
    },
    setAuthToken: (state, payload) => {
      state.authorizationId = payload
    },

    setAuthUser: (state, user) => {
      state.user = user
    },
    setUserAuthToken: (state, authToken) => {
      state.user = {
        ...(state.user || {}),
        authToken: authToken
      }
    },
    setUserAuthTelephone: (state, authTelephone) => {
      state.user = {
        ...(state.user || {}),
        telephone: authTelephone
      }
    },
    
    setGuestTelephone: (state, telephone) => {
      state.guestTelephone = telephone;
    }
  },

  actions: {
    fetchStoreDetails: ({commit, dispatch, getters}) => {
      return api.get(`/owa/store`).then(store => {
        dispatch('fetchManifest', store.data[0].groupId)

        return api.get(`/rwa/rewards/coupons`).then(({data: coupons}) => {
          const storeObj = {
            api_status: store.status,
            ...store.data[0],
            coupons: setPurchasableCoupons(coupons, get(getters.getCouponDetails, 'coupons', []))
          }

          commit('setStore', storeObj)

          return storeObj
        })
      })
    },
    fetchPosSettings: ({commit}) => {
      return api.get(`/owa/payment_types_for_tip`).then((res) => {
        commit("setPosSetting", res.data);
      });
    },
    fetchGiftcardStore: ({commit}) => {
      return api.get(`/giftcard/selfcare/customization`).then(res => {
        commit('setGiftcardCustomization', res.data)
      })
    },
    fetchDepositStore: ({commit}) => {
      return api.get(`/rwa/selfcare/deposit/customization`).then(res => {
        commit('setDepositCustomization', res.data)
      })
    },
    fetchManifest: ({commit}, gid) => {
      return api.get('/owa/manifest/' + gid).then(res => {
          const manifest = res.data
          const primaryColor = manifest.meta.primary || '#1e9d84'
          const secondaryColor = manifest.meta.secondary || '#E97283'
          commit('setManifest', manifest)

          localStorage.setItem('storePrimary', primaryColor)

          var bodyStyles = document.body.style;
          bodyStyles.setProperty('--primary-color', primaryColor);
          bodyStyles.setProperty('--secondary-color', secondaryColor);

          const hex = primaryColor
          const r = parseInt(hex.slice(1, 3), 16)
          const g = parseInt(hex.slice(3, 5), 16)
          const b = parseInt(hex.slice(5, 7), 16)
          const textColor = (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5 ? '#000000' : '#ffffff'
          bodyStyles.setProperty('--primary-text', textColor);

          // Update Vuetify theme so computed colors react to the manifest primary
          const theme = window.__vuetify__ && window.__vuetify__.$vuetify && window.__vuetify__.$vuetify.theme
          if (theme) {
            theme.themes.light.primary = primaryColor
            theme.themes.dark.primary = primaryColor
          }
        })
    }
  },

  plugins: [vuexLocalStorage.plugin]
})
